export default [{ code: 'system', name: '系统设置', icon: 'el-icon-s-home', parentKey: '', selfFlg: 'system' }];
